import type { QuestionVoiceRecordSchema } from '@repo/schemas/quiz/questionVoiceRecord';

import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { cn } from '@repo/lib/cn';
import { questionVoiceRecordSchema } from '@repo/schemas/quiz/questionVoiceRecord';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { QuestionContentFormField } from '@/components/features/quiz/question/question-builder';
import { Form } from '@/components/ui/form';
import { formErrorToast } from '@/utils/form';

import type { QuestionVoiceFormProps } from '.';

export function QuestionVoiceForm(questionVoiceFormProps: QuestionVoiceFormProps) {
  const { data, onSubmit = () => {}, className, ...props } = questionVoiceFormProps;

  const form = useForm<QuestionVoiceRecordSchema>({
    defaultValues: data,
    mode: 'onChange',
    resolver: standardSchemaResolver(questionVoiceRecordSchema),
  });

  //trigger validation on component mount
  useEffect(() => {
    form.trigger();
  }, []);

  return (
    <Form {...form}>
      <form {...props} noValidate onSubmit={form.handleSubmit(onSubmit, () => formErrorToast(form, questionVoiceRecordSchema))} className={cn('h-full', className)}>
        <div className="divide-border-primary divide-y">
          <QuestionContentFormField />
        </div>
      </form>
    </Form>
  );
}
